import { CreateGroupPurchaseRequest } from "api"
import {
  Dispatch,
  FC,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react"

export enum GroupPurchasesSteps {
  GroupName = 1,
  Amount = 2,
  LeaderDetails = 3,
  FAIL = 4,
  LOADER = 5,
}

export type GroupPurchasesContextType = {
  groupPurchasesData: CreateGroupPurchaseRequest
  setGroupPurchasesData: Dispatch<SetStateAction<CreateGroupPurchaseRequest>>
  groupPurchasesSteps: GroupPurchasesSteps
  setGroupPurchasesSteps: Dispatch<SetStateAction<GroupPurchasesSteps>>
  isAdmin: boolean
  setIsAdmin: Dispatch<SetStateAction<boolean>>
  prevPageId: number | null
  setPrevPageId: Dispatch<SetStateAction<number | null>>
  prevPath: string | null
  setPrevPath: Dispatch<SetStateAction<string | null>>
  changed: boolean
  setChanged: Dispatch<SetStateAction<boolean>>
}

export const GroupPurchasesContext =
  createContext<GroupPurchasesContextType>(null)

export const GroupPurchasesContextProvider: FC = ({ children }) => {
  const [groupPurchasesData, setGroupPurchasesData] =
    useState<CreateGroupPurchaseRequest>()
  const [groupPurchasesSteps, setGroupPurchasesSteps] =
    useState<GroupPurchasesSteps>(GroupPurchasesSteps.LOADER)
  const [isAdmin, setIsAdmin] = useState(false)
  const [prevPageId, setPrevPageId] = useState(null)
  const [prevPath, setPrevPath] = useState(null)
  const [changed, setChanged] = useState(false)

  return (
    <GroupPurchasesContext.Provider
      value={{
        changed,
        setChanged,
        prevPath,
        setPrevPath,
        prevPageId,
        setPrevPageId,
        groupPurchasesData,
        setGroupPurchasesData,
        groupPurchasesSteps,
        setGroupPurchasesSteps,
        isAdmin,
        setIsAdmin,
      }}
    >
      {children}
    </GroupPurchasesContext.Provider>
  )
}

export const useGroupPurchasesContext = () => useContext(GroupPurchasesContext)
